import React from 'react';

const points = [
  {
    icon: '🔒',
    title: 'Data Stays In Your Org',
    desc: 'ATLAS ITSM is deployed within your own infrastructure. No ticket data, user information, or configuration ever leaves your environment.',
  },
  {
    icon: '🛡️',
    title: 'Encrypted At Rest & In Transit',
    desc: 'All data is encrypted using AES-256 at rest and TLS 1.3 in transit. Sensitive fields have an additional layer of field-level encryption.',
  },
  {
    icon: '📋',
    title: 'Full Audit Trail',
    desc: 'Every action — ticket updates, role changes, configuration edits — is logged with a timestamp and user identity. Immutable and exportable.',
  },
  {
    icon: '🧩',
    title: 'Granular Access Control',
    desc: 'Role-based access means users can only see and act on data they\'re authorised for. Least-privilege by design, configurable by your team.',
  },
  {
    icon: '📊',
    title: 'Compliance-Ready',
    desc: 'Designed with ISO 27001 and IT governance best practices in mind. Export audit logs and access reports for compliance reviews on demand.',
  },
  {
    icon: '🔑',
    title: 'SSO & Directory Integration',
    desc: 'Integrate with your existing Active Directory or LDAP setup. Centrally manage user provisioning and de-provisioning without manual overhead.',
  },
];

export default function Privacy() {
  return (
    <section id="privacy" style={{ padding: '100px 0' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 32px' }}>
        <div style={{ textAlign: 'center', marginBottom: '64px' }}>
          <div style={{ display: 'inline-block', background: 'rgba(45,106,79,0.12)', border: '1px solid rgba(82,183,136,0.2)', borderRadius: '100px', padding: '5px 16px', fontSize: '12px', color: '#52b788', fontWeight: 600, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '20px' }}>
            Security & Privacy
          </div>
          <h2 style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 'clamp(32px,4vw,52px)', fontWeight: 800, letterSpacing: '-1.5px', marginBottom: '16px' }}>
            Security that earns trust
          </h2>
          <p style={{ fontSize: '17px', color: '#a8b4cc', maxWidth: '520px', margin: '0 auto' }}>
            ATLAS ITSM is built on a security-first foundation. Your data, your control — always.
          </p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '24px' }} className="privacy-grid">
          {points.map(p => (
            <div key={p.title} style={{ background: '#141c35', border: '1px solid rgba(255,255,255,0.07)', borderRadius: '16px', padding: '28px 24px', transition: 'border-color 0.2s' }}
              onMouseEnter={e => e.currentTarget.style.borderColor = 'rgba(82,183,136,0.25)'}
              onMouseLeave={e => e.currentTarget.style.borderColor = 'rgba(255,255,255,0.07)'}>
              <div style={{ fontSize: '28px', marginBottom: '16px' }}>{p.icon}</div>
              <h3 style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: '17px', fontWeight: 700, color: '#fff', marginBottom: '10px' }}>{p.title}</h3>
              <p style={{ fontSize: '14px', color: '#a8b4cc', lineHeight: 1.65 }}>{p.desc}</p>
            </div>
          ))}
        </div>
      </div>
      <style>{`@media(max-width:900px){ .privacy-grid{ grid-template-columns:repeat(2,1fr) !important; } } @media(max-width:600px){ .privacy-grid{ grid-template-columns:1fr !important; } }`}</style>
    </section>
  );
}
